import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
  gl_Position = vec4(aPos, 1.0);
  vPos = aPos;
}`;

this.fragmentShader = `#version 300 es
precision mediump float;

in vec3 vPos;
out vec4 fragColor;

uniform float uTime;

void main() {
  vec3 lightSource = vec3(1.0);
  vec3 color = vec3(0.0);

  int no = 5;

  float radius = 0.25;

  for (int i = 0; i < no; i++) {
    // position each sphere center in a circle
    float angle = float(i) / float(no) * ( 3.14 * 2.0 ); // TWO_PI
    vec2 center = vec2(cos(angle + uTime * 0.5), sin(angle + uTime * 0.5));

    // vector from sphere center to fragment position
    vec2 rel = vPos.xy - center;
    float dist = length(rel);

    if (dist < radius) {
      float z = sqrt(radius * radius - dist * dist);
      vec3 p = vec3(rel, z);

      float cosineValue = dot(p, lightSource);
      float diffused = max(0.0, cosineValue);
      color = max(color, vec3(diffused)); // keep brightest
    }
  }

  fragColor = vec4(color, 1.0);
}

`;

  let startTime = Date.now() / 1000;

  this.update = () => {
    setUniform('1f', 'uTime', Date.now() / 1000 - startTime);
  };
}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);
  const [scene, setScene] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);
    setScene(newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore in non-HMR env */ }
    return () => { try { if (typeof canvas.stopRender === 'function') canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style = { { display: "flex", justifyContent: "center", gap : "16px" } }>
        <canvas ref={canvasRef} width={400} height={400} style={{ width : "400px", height : "400px", display: "block", margin: "0 auto", background: "#f6f6f6" }} />
        <pre>{ scene?.fragmentShader }</pre>
    </div>
  );
}
